export default __webpack_public_path__ + "static/PromptIconOne-2ff2f4c848a2de8ee6b9055940ddc255.png";